import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {useLanguage} from '../i18n/LanguageProvider';
// Statistics always show the sourced value, including before entering the viewport.
export function AnimatedNumber({value,format='number'}:{value:number;format?:'number'|'year'}){
 return <span className={format==='year'?'num-year':'num-live'} style={{fontVariantNumeric:'tabular-nums'}}>{format==='year'?String(value):value.toLocaleString('vi-VN')}</span>;
}
// Short headings reveal real text in place, without random glyphs or layout shifts.
export function TechEffects(){
 const {pathname}=useLocation(),{locale}=useLanguage();
 useEffect(()=>{
  if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  const animations:Animation[]=[];
  const observer=new IntersectionObserver(entries=>{
   for(const entry of entries){
    if(!entry.isIntersecting)continue;
    observer.unobserve(entry.target);
    animations.push(entry.target.animate([{opacity:.8},{opacity:1}],{duration:280}));
   }
  },{threshold:.25});
  document.querySelectorAll('#main-content h1,#main-content h2').forEach(el=>{
   if((el.textContent||'').length<=48&&!el.closest('.tech-text,.ref-invitation,.news-page,.article-page'))observer.observe(el);
  });
  return()=>{observer.disconnect();animations.forEach(animation=>animation.cancel())};
 },[pathname,locale]);
 return null;
}
